module.exports = __webpack_public_path__ + "static/media/substancedesigner.d9a0ad17.png";